import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { PitchCardModalBase } from '../pitchcard-modal-base';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import {
  ContactModalComponent,
  CountryInputComponent,
  DoneModalComponent
} from '@Shared/components';
import { NotificationService } from '@Shared/services';
import { UserCommonApiService } from '@App/common/services';
import { PitchCardModalsWrapperService } from '@App/modules/pitch-card-shared/services';
import { AppSettings } from '@Shared/app.settings';

@Component({
  selector: 'app-pitchcard-contact-dialogs',
  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    DialogModule,
    InputTextModule,
    ContactModalComponent,
    CountryInputComponent,
    DoneModalComponent
  ],
  templateUrl: './pitchcard-contact-dialogs.component.html'
})
export class PitchCardContactDialogsComponent extends PitchCardModalBase {
  @Input() showContactMeDialog: any;
  @Input() showDoneDialog: any;
  @Input() showContactInfoDialog: any;
  @Input() showContactSwapDialog: any;
  @Input() showSentDialog: any;
  @Input() isMobile: any;
  @Input() isSearch: any;
  @Input() isEmbedded: any;
  @Input() isPortraitMode: any;
  @Input() userName: any;
  @Input() currentPitchCard: any;
  @Output() contactMenuClear = new EventEmitter<void>();

  private fb = inject(FormBuilder);
  contactSwapSubmitting = false;
  contactSwapForm = this.fb.group({
    name: ['', [Validators.required, Validators.minLength(2)]],
    businessName: [''],
    phone: ['', Validators.required],
    email: [
      '',
      [Validators.required, Validators.pattern(AppSettings.EMAIL_PATTERN)]
    ],
    notes: ['', [Validators.maxLength(1000)]]
  });
  private notificationService = inject(NotificationService);
  private userCommonService = inject(UserCommonApiService);
  private pitchCardModalsWrapperService = inject(PitchCardModalsWrapperService);
  private cdr = inject(ChangeDetectorRef);

  onContactModalHide() {
    this.onFlag('showContactMeDialog', false);
    this.pitchCardModalsWrapperService.showContactMeDialog.next(false);
  }

  onContactModalSubmit({ data }) {
    this.userCommonService.contactSales(data).subscribe({
      next: () => {
        this.onFlag('showContactMeDialog', false);
        this.pitchCardModalsWrapperService.showContactMeDialog.next(false);
        this.onFlag('showDoneDialog', true);
      },
      error: ({ message }) => {
        this.notificationService.showNotification('ERROR', message);
      }
    });
  }

  onClickDoneDialog() {
    this.onFlag('showDoneDialog', false);
    this.pitchCardModalsWrapperService.showContactMeDialog.next(false);
  }

  closeContactSwapDialog() {
    this.onFlag('showContactSwapDialog', false);
    if (!this.contactSwapSubmitting) {
      this.contactSwapForm.reset();
    }
    this.onFlag('showSentDialog', false);
    this.pitchCardModalsWrapperService.disableContactSwapDialog();
    this.contactMenuClear.emit();
  }

  onContactSwapSubmit() {
    if (this.contactSwapForm.invalid) {
      return;
    }

    this.contactSwapSubmitting = true;
    const { name, businessName, email, phone, notes } =
      this.contactSwapForm.value;

    // Calculate next day at 9:00 AM local time, converted to UTC milliseconds since epoch
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(9, 0, 0, 0);
    const notifyAtMs = tomorrow.getTime();

    this.userCommonService
      .createLead({
        businessId: this.currentPitchCard.id,
        name,
        email,
        phone,
        businessName,
        notes,
        notifyAt: notifyAtMs
      })
      .subscribe({
        next: () => {
          this.contactSwapSubmitting = false;
          this.contactSwapForm.reset();
          this.onFlag('showContactSwapDialog', false);
          this.onFlag('showSentDialog', true);
          this.pitchCardModalsWrapperService.disableContactSwapDialog();
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.contactSwapSubmitting = false;
          this.cdr.detectChanges();
          this.notificationService.handleErrorMessage(error);
        }
      });
  }
}
